import { gql } from '@apollo/client';

export const SUBMIT_PARENT_REGISTRATION = gql`
  mutation submitParentRegistration($input: FamilyNewModelRegistationInput) {
    registerFamilyNewModel(input: $input) {
      guardianId
      managedBy
    }
  }
`;
